
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.508 32.624c-1.7-.1-3.7-.2-5.4 0-4.9.4-4.1 6.9-4 10.4.2 5.7 5.4 4.8 9.5 4.8 4.9-.5 4.1-6.9 3.9-10.4 0-2.6-1.3-4.7-4-4.8zm.2 12c-1.9 0-5.6.7-7.2-.5-1.3-1-.9-3-.9-4.4 0-2 0-3.7 2.5-4 1.1-.1 2.2 0 3.3 0 1.1 0 2.7-.2 3.7.3 1.6.9 1.2 2.8 1.2 4.3-.1 2.1.1 4-2.6 4.3z"}}),_c('path',{attrs:{"d":"M21.208 39.824c0-.2-.1-.4-.1-.6 0-.2-.1-.4-.2-.5-.2-.5-.4-.9-.7-1.2 0 0 0-.1-.1-.1-.6-.6-1.3-1-2.2-1-2 0-3.4 1.8-3.4 3.7 0 1 .4 2 1.1 2.7l.1.1c.5.5 1.2.9 2.1.9 2 .1 3.2-1.5 3.5-3.3 0-.1.1-.2 0-.4-.1-.1-.1-.2-.1-.3zm-4.3 2.6c-.1 0-.3-.1-.4-.1l3.5-3.5c.1.1.2.2.2.3-1 1.1-2.1 2.2-3.3 3.3zm-1.5-1.1l3.4-3.4c.1.1.2.1.4.2l-3.5 3.5-.3-.3zm2-3.5l-2.3 2.3c0-1.4 1.1-2.1 2.3-2.3zm.9 4.6l2.3-2.3c-.1 1.4-1.1 2.2-2.3 2.3zM49.608 48.324c-7-7.1-14.1-14.1-21.1-21.2-2.6-6.6-5.1-13.1-7.7-19.7-.6-1.5-1.3 1.4-1 2.2 1.9 4.8 3.8 9.5 5.6 14.3-3.3-3.3-6.6-6.6-9.8-9.9-.9-.8-1.4 2.2-.7 2.8 4.3 4.3 8.5 8.6 12.8 12.8 3 7.5 5.9 15 8.9 22.6.6 1.5 1.3-1.4 1-2.2-2.3-5.7-4.5-11.5-6.8-17.2 6.1 6.1 12.1 12.2 18.2 18.3.8.8 1.2-2.2.6-2.8z"}})])
          )
        }
      }
    